<template>
<div class="chapter">
<div class="inner_page">
<p class="dedi1" id="dedi"><em>This book is dedicated to my wife, Donna</em>.</p>
<p class="dedi"><em>Her patience with me is unfathomable and</em></p>
<p class="dedi"><em>her contributions to my life are incalculable</em>.</p>
<p class="dedi"><em>I love you!</em><a id="page_vi"></a><a id="page_vii"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedi.vue?2b34786a